<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Skills"><skills></skills></mat-tab>
  <mat-tab label="Subtypes"><subtypes></subtypes></mat-tab>
  <mat-tab label="Programs"><programs></programs></mat-tab>
  <mat-tab label="Prizes"><prizes></prizes></mat-tab>
</mat-tab-group>
